import { Component, OnInit, Input, HostListener } from '@angular/core';

declare var jwplayer: any;

@Component({
  selector: 'app-question-jwplayer',
  templateUrl: './question-jwplayer.component.html',
  styleUrls: ['./question-jwplayer.component.css']
})
export class QuestionJwplayerComponent implements OnInit {

  @Input() questionUrl: any;
  @Input() playerindex: any;

  playerId: any;

  internetError: any;
  playerJW: any;


  // image = 'https://content.jwplatform.com/thumbs/qn1mMPum-720.jpg';


  constructor() { }

  ngOnInit() {
    this.playerId = "player" + this.playerindex;
    setTimeout(() => {
      this.configurePlayer(this.questionUrl);
    }, 0);

  }


  configurePlayer(video) {
    let playername = "player" + this.playerindex;
    this.internetError = false;
    this.playerJW = jwplayer(playername).setup({
      file: video,
      image: 'assets/images/Thumbnail-Video-Interview.jpg',
      aspectratio: '16:13',
      autostart: false,
      repeat: false,
      primary: 'html5',
      id: 'player',
      stretching: "uniform",
      height: '100%',
      width: '100%',
      mute: false,
      renderCaptionsNatively: false,
    }).setCaptions({ 'fontSize': 12, 'backgroundOpacity': 100, 'backgroundColor': '#000000', 'fontFamily': 'Arial' });

  }

  pausePlayer() {
    this.playerJW.pause();
  }


}
